import { createContext, useEffect } from 'react';
import { User } from '../../types/Types';
import UserHooks from './User.hooks';

export const UserContext = createContext({
  userState: {
    users: [{} as User],
    isLoading: false,
    errMessage: '',
  },
  create: (param: User) => {},
  editUser: (param: User) => {},
  deleteUser: (paramId: string) => {},
});

export function UserProvider(props: any) {
  const { state, findAll, create, editUser, deleteUser } = UserHooks();

  useEffect(() => {
    findAll();
    return () => {
      findAll();
    };
  }, [findAll]);

  return (
    <UserContext.Provider
      value={{ userState: state, create, editUser, deleteUser }}
    >
      {props.children}
    </UserContext.Provider>
  );
}
